import React, { useState, useEffect, useContext, createContext } from "react";
import "../../styles/pages/enquiry/Enquiry.scss";
import NonClubsMember from "./NonClubsMember";
import WorkshopDetailPage from "./WorkshopDetailPage";
import WorkshopChangePage from "./WorkshopChangePage";
import { GlobalContext } from "../../App";
import { fetchEnquiryHistory } from "../../api/apiManagement";
import { Trans, useTranslation } from "react-i18next";

export const enquiryContext = createContext();
function Enquiry() {
  const { setIsLoading, isLogin, infoData } = useContext(GlobalContext);
  const { t, i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [enquiryLoginData, setenquiryLoginData] = useState({
    email: "",
    phone: "",
  });
  const [notExistCourse, setNotExistCourse] = useState(false);
  const [enquiryCourseData, setEnquiryCourseData] = useState();
  const [userData, setUserData] = useState();
  const [error, setError] = useState(false);
  const [currentLang, setCurrentLang] = useState("");
  const [workshopChangeData, setWorkshopChangeData] = useState([]);
  const [workshopRecordId, setWorkshopRecordId] = useState();
  const dataValue = {
    enquiryLoginData,
    setenquiryLoginData,
    handleEnquiry,
    error,
    enquiryCourseData,
    setCurrentStep,
    currentLang,
    setCurrentLang,
    workshopChangeData,
    setWorkshopChangeData,
    workshopRecordId,
    setWorkshopRecordId,
  };

  useEffect(() => {
    if (isLogin) {
      setUserData(JSON.parse(localStorage.getItem("user_data")));
    }
  }, [isLogin]);

  useEffect(() => {
    if (isLogin) {
      if (userData) {
        handleEnquiry();
      }
    }
  }, [isLogin, userData]);

  function handleEnquiry() {
    setIsLoading(true);
    let data = {
      lang: i18n.language,
      email: enquiryLoginData.email,
      phone: 852 + enquiryLoginData.phone,
    };
    if (isLogin) {
      data.sua_id = userData.sua_id;
      data.token = JSON.parse(localStorage.getItem("jwt"))?.signature;
    }

    setCurrentLang(data.lang);
    fetchEnquiryHistory(data)
      .then((res) => {
        if (res.data.Data.length === 0) {
          setNotExistCourse(true);
        } else {
          setEnquiryCourseData(res.data.Data);
          setCurrentStep(1);
          setNotExistCourse(false);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
        setIsLoading(false);
      });
  }

  return (
    <enquiryContext.Provider value={dataValue}>
      <div className="enquiry-container">
        <div className="title">
          {Object.keys(infoData).length === 0 ? (
            <></>
          ) : i18n.language === "hk" ? (
            <span
              dangerouslySetInnerHTML={{ __html: infoData.title_tc }}
            ></span>
          ) : (
            <span
              dangerouslySetInnerHTML={{ __html: infoData.title_eng }}
            ></span>
          )}
        </div>
        <div className="workshop-event">
          {" "}
          <Trans i18nKey="enquiry:courseInquiry" />
        </div>
        {currentStep === 0 ? (
          <>
            <div>{isLogin ? <div>Loading...</div> : <NonClubsMember />}</div>
            {notExistCourse ? (
              <div className="error">
                <Trans i18nKey="enquiry:noCourse" />
              </div>
            ) : (
              <></>
            )}
          </>
        ) : currentStep === 1 ? (
          <WorkshopDetailPage />
        ) : currentStep === 2 ? (
          <WorkshopChangePage />
        ) : (
          <></>
        )}
      </div>
    </enquiryContext.Provider>
  );
}

export default Enquiry;
